export async function getAsync<T>(url: string, token: string = "", mockData: T | null = null): Promise<T | null> {    
    try {
        if (mockData != null) {
            return mockData;
        }

        let headers = new Headers();
        if(token !== '') {
            headers.append('Authorization', 'bearer' + token);
        }

        let requestData : RequestInit = {
            method: "GET",
            headers: headers,
        }

        const response = await (fetch(url, requestData).catch(handleError));

        if (response.ok) {
            const data:T = await response.json();
            return data;
        }
        else if (response.status === 401) {
            const path = await response.json();
            if (path.redirect) {
                handleRedirect(path.redirect);
            }

            return Promise.reject(response);
        }
        else {
            return Promise.reject(response);
        }
    }
    catch (error) {
        console.error(error);
        return null;
    }
}

export async function getAsStreamAsync(url: string, token: string = ""): Promise<any> {
    try {
        let headers = new Headers();
        if(token !== '') {
            headers.append('Authorization', 'bearer' + token);
        }

        let requestData = {
            method: "GET",
            headers: headers,
            responseType: 'blob'
        }

        const response: Response = await (fetch(url, requestData).catch(handleError));
        return response;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}

export async function postAsync<T, B>(url: string, body: B, token: string = "", mockData: T | null = null): Promise<T | null> {
    try {
        if (mockData != null) {
            return mockData;
        }

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if(token !== '') {
            headers.append('Authorization', 'bearer' + token);
        }

        let requestData = {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body)
        }
        const response = await (fetch(url, requestData).catch(handleError));
        
        if (response.ok) {
            const data:T = await response.json();
            return data;
        }
        else if (response.status === 401) {
            const path = await response.json();
            if (path.redirect) {
                handleRedirect(path.redirect);
            }

            return Promise.reject(response);
        }
        else {
            return Promise.reject(response);
        }
    }
    catch (error) {
        console.error(error);
        return null;
    }
}

export async function deleteAsync<T, B>(url: string, body: B, token: string = '', mockData: T | null = null): Promise<T | null>{
    try{
        if (mockData != null) {
            return mockData;
        }

        let headers = new Headers();
        if(token !== ''){
           headers.append('Authorization', 'bearer' + token);
        }

       let requestData = {
           method: 'delete',
           headers: headers
       }

       const response = await fetch(url, requestData)
        switch(response.status) {
            case 404:
                // handle redirect
                break;
        }
        const data:T = await response.json();
        return data;
    }
    catch(error) {
        console.error(error);
        return null;
    }
}

export async function putAsync<T, B>(url: string, body: B, token: string = '', mockData: T | null = null): Promise<T | null> {
    try {
        if (mockData != null) {
            return mockData;
        }

       let headers = new Headers();
       headers.append('Content-Type', 'application/json');
       if(token !== ''){
           headers.append('Authorization', 'bearer' + token);
       }

       let requestData = {
           method: 'put',
           headers: headers,
           body: JSON.stringify(body)
       }

       const response = await fetch(url, requestData)
       switch(response.status) {
           case 404:
               //handle redirect
               break;
       }
       const data:T = await response.json();
       return data;
    }
    catch(error) {
       console.error(error);
       return null;
    }
}

var handleRedirect = function (path: string) {
    console.warn("Redirecting: ", path);
    window.location.href = path;
}

var handleError = function (err: any) {
    console.warn(err);
    return new Response(JSON.stringify({
        code: 400,
        message: 'Stupid network Error'
    }));
};
